<template><div><h1>如何贡献</h1>
<h2>文档更新</h2>
<p>如果修改了组件代码，需要在组件目录的<code>metas.yml</code>加上changes，直接使用<code>next</code>作为版本号(如果已经存在该版本号，则直接添加变更条目即可)。</p>
<p>中括号内为变更类型，可选值 <code>fix</code> <code>enhance</code> <code>feature</code> <code>change</code></p>
<p>比如：</p>
<pre class="hljs"><code><span class="hljs-attr">changes:</span>
<span class="hljs-attr">  next:</span>
<span class="hljs-attr">    en:</span>
<span class="hljs-bullet">      -</span> <span class="hljs-string">'[fix] fix *** bug #issueId'</span>
<span class="hljs-bullet">      -</span> <span class="hljs-string">'[feature] new feature'</span>
<span class="hljs-attr">    zh-CN:</span>
<span class="hljs-bullet">      -</span> <span class="hljs-string">'[fix] 修复 *** bug #issueId'</span>
</code></pre>
<div class="tip">
<p>当文档相关的 <code>PR</code>被合并后，文档服务器会在<code>5分钟</code>内拉取最新代码并执行<code>npm run build-docs</code>及<code>npm run build</code>实现文档及<code>demo</code>更新。</p>
</div>
<h2>为什么使用 next 为版本号</h2>
<p><code>next</code> 表示下个版本，未发布时在 <code>changelog</code> 里显示 <code>next</code>，提醒用户一些开发中的代码尚未发布。</p>
<p>当进行版本发布时，文档中的 <code>next</code> 会被脚本代替成真正的版本号，至此发布完毕。</p>
<p>这样的最大好处是更新代码时可以直接写 <code>changelog</code> 不用在意要写哪个版本号，在发布时翻 commit 记录写 <code>changelog</code> 是件比较浪费时间的事。</p>
</div></template><script>
export default {
  head: {"title":"如何贡献 | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// pr-276.vue?5daf1002